export const SET_ACTIVE_PLAYLIST = 'SET_ACTIVE_PLAYLIST';
export const CREATE_PLAYLIST_EVENT = 'CREATE_PLAYLIST_EVENT';
export const DELETE_PLAYLIST_EVENT = 'DELETE_PLAYLIST_EVENT';
export const SET_LAYOUTS = 'SET_LAYOUTS';
export const UPDATE_EVENT = 'UPDATE_EVENT';
